import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { ToastComponent }  from './shared/components/toast/toast.component';
import { GlobalSpinner }   from './shared/components/global-spinner/global-spinner';
import { SessionExpiredModalComponent } from './shared/components/session-expired-modal/session-expired-modal.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastComponent, GlobalSpinner, SessionExpiredModalComponent],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App {
  protected readonly title = signal('frontend');
}
